const ColorBlind = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 64 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_127_3309)">
        <path
          d="M62.5735 40.8867C63.0558 41.6101 63.0558 42.4759 63.1547 43.2982C63.3259 44.6293 63.5284 45.9508 63.4754 47.3133C63.4175 48.8037 63.6731 50.2771 63.5381 51.7939C63.1695 56.1455 61.9008 60.373 59.8123 64.2083C54.8446 73.3576 47.1857 78.9908 36.9874 80.5559C24.163 82.5237 13.6609 78.0238 5.90555 67.5941C1.41291 61.5653 -0.345076 54.5913 0.0552341 47.0963C0.173398 44.8874 0.378369 42.6664 1.05841 40.5298C2.98943 40.8228 4.9536 40.8228 6.88462 40.5298C6.86909 40.7384 6.84252 40.9461 6.80503 41.1519C6.01165 44.598 5.59928 48.0609 5.92965 51.613C6.48189 57.813 9.09597 63.0508 13.2486 67.5603C15.1488 69.6246 17.5435 71.1197 19.9791 72.4436C23.3335 74.2667 27.0183 75.0288 30.8308 75.2554C31.6966 75.3085 31.8582 75.0143 31.8557 74.2113C31.8268 64.2164 31.8188 54.2207 31.8316 44.2242C31.8316 43.1728 31.8533 42.119 31.863 41.0651C41.8225 41.0651 51.782 41.0651 61.7415 41.0651C62.0213 41.0796 62.3444 41.1737 62.5735 40.8867Z"
          fill="black"
        />
        <path
          d="M62.5742 40.8866C62.3331 41.1736 62.022 41.0795 61.735 41.0795C51.7755 41.0795 41.816 41.0795 31.8565 41.0795C31.8565 40.7178 31.8348 40.3561 31.8348 39.9968C31.8348 29.2704 31.8348 18.5448 31.8348 7.82006L31.8348 6.6746C31.6851 6.74565 31.5401 6.8262 31.4007 6.91575C25.7664 11.4087 20.6953 16.5657 16.2975 22.2746C12.0821 27.8042 8.78562 33.8088 6.89259 40.5369C4.96158 40.8299 2.99742 40.8299 1.06641 40.5369C1.83809 36.5797 3.32358 32.878 5.09362 29.2776C8.18758 22.9884 12.386 17.4878 17.0812 12.3272C20.97 8.08902 25.2492 4.22643 29.8622 0.790529C31.2102 -0.224714 32.4135 -0.265713 33.7471 0.742296C36.8001 3.04769 39.7759 5.43508 42.4285 8.2059C44.3047 10.1616 46.3327 11.963 48.098 14.0297C52.3229 18.9757 56.0921 24.2231 58.928 30.1096C60.4839 33.3912 61.6961 36.825 62.5453 40.3561C62.5739 40.5314 62.5836 40.7092 62.5742 40.8866Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3309">
          <rect width="63.5769" height="81" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ColorBlind;
